/**
 * Single source of truth for form field sizing
 * Used by both Input and SelectTrigger to ensure identical dimensions
 * TRUE GLASSMORPHISM styling - semi-transparent with blur
 * Pure glassmorphism - no opacity changes on hover/focus/active
 * Autofill override to maintain glassmorphism (the sheet theme replaces it with its own
 * `input:-webkit-autofill` rule in theme-sheet-product.css section 3).
 */

export const FIELD_BASE =
  "w-full h-12 px-4 rounded-xl bg-white/10 backdrop-blur-xl text-[#4B5563] placeholder:text-[#94A3B8] border border-[rgba(96,165,250,0.3)] focus:outline-none focus:ring-2 focus:ring-[rgba(96,165,250,0.3)] focus:border-[rgba(96,165,250,0.6)] transition-all shadow-sm [&:-webkit-autofill]:bg-white/10 [&:-webkit-autofill]:text-[#4B5563] [&:-webkit-autofill]:shadow-[0_0_0_1000px_rgba(255,255,255,0.1)_inset]";

/**
 * Additional classes for select triggers that need icon/caret space
 * Add pr-8 to prevent text overlapping with dropdown caret
 */
export const SELECT_TRIGGER_ADDON = "justify-between pr-8";

/**
 * Combined class for SelectTrigger components
 */
export const SELECT_TRIGGER_BASE = `${FIELD_BASE} ${SELECT_TRIGGER_ADDON}`;

